import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  settingsLeftMenuContainer: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      flex: "1 0 17%",
      padding: "0 32px",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      borderRight: `solid 1px ${theme.palette.border.default}`,
      maxWidth: 200,
      gap: 24,
    },
  },
  selectorMobile: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  headerText: {
    fontSize: 20,
    color: "#16871c",
    lineHeight: 1.5,
    textAlign: "right",
  },
  menu: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    "& > a": {
      textDecoration: "none",
      textAlign: "right",
    },
    "& .MuiFormControlLabel-root": {
      marginBottom: 24,
      gap: "10px",

      "&:hover": {
        "& .MuiIconButton-colorPrimary": {
          backgroundColor: "rgb(22 135 28 / 4%)",
          transition: "background-color 0.2s",
        },
      },
    },
  },
  radio: {
    width: 22,
    height: 22,
    "& .MuiSvgIcon-root": {
      width: 22,
      height: 22,
      color: "var(--LightGrey)",
      borderRadius: "50%",
    },
    "&.Mui-checked": {
      "& .MuiSvgIcon-root": {
        width: 22,
        height: 22,
        color: "unset",
        backgroundColor: "unset",
        borderRadius: "50%",
      },
    },
  },
}));
